import angular from "angular";

angular
    .module('app')
    .component('questionForm', {
        template: require('./question-form.html'),
        controller: ['$http', '$rootScope', 'Notifier', '$scope', controller],
        bindings: {
            resolve: '<',
            close: '&',
        }
    });

function controller($http, $rootScope, Notifier, $scope) {

    let $ctrl = this;

    $ctrl.id = null;
    $ctrl.text = null;
    $ctrl.answers = [];

    $ctrl.$onInit = function () {

        $ctrl.courseId = $ctrl.resolve.courseId;
        $ctrl.lessonId = $ctrl.resolve.lessonId;
        $ctrl.quizId = $ctrl.resolve.quizId;

        if ($ctrl.resolve.question) {
            $ctrl.id = $ctrl.resolve.question.id;
            $ctrl.text = $ctrl.resolve.question.text;
            $ctrl.answers = window.angular.copy($ctrl.resolve.question.answers);
        } else {
            $ctrl.answers.push({
                text: "",
                is_correct: false,
            });
        }
    };

    $ctrl.delAnswer = function (answer, index) {
        $ctrl.answers.splice(index, 1);
    };

    $ctrl.addAnswer = function () {
        $ctrl.answers.push({
            text: "",
            is_correct: false,
        });
    };

    $ctrl.save = function () {

        let params = {
            text: $ctrl.text,
            answers: $ctrl.answers,
        };

        let link;

        if ($ctrl.id) {
            link = `/admin/courses/${$ctrl.courseId}/lessons/${$ctrl.lessonId}/quiz/${$ctrl.quizId}/question/${$ctrl.id}`
        }
        else {
            link = `/admin/courses/${$ctrl.courseId}/lessons/${$ctrl.lessonId}/quiz/${$ctrl.quizId}/question`;
        }
        $http.post(link, params)
            .then(
                function (response) {
                    Notifier.success('Сохранено', 2);
                    $ctrl.close({
                        $value: {
                            id: $ctrl.id || response.data.id,
                            text: $ctrl.text,
                            answers: $ctrl.answers,
                        },
                    });
                },
                function (error) {
                    Notifier.error(error.data.message, 2);
                }
            );
    };
}